module.exports = __webpack_public_path__ + "static/media/bluedot.5e82d241.png";